<div class="col-12 glossary-list">
    <!-- Title/Header -->
    <p-toolbar aria-label="Advanced Search">
        <div class="p-toolbar-group-start">
            <span class="section-header">Glossary of Terms</span>
        </div>
    </p-toolbar>
    <!-- Letter Index -->
    <div class="mt-3 ms-3">
        <a [routerLink]="[]" fragment="a">A</a>
        <a [routerLink]="[]" fragment="b">B</a>
        <a [routerLink]="[]" fragment="c">C</a>
        <a [routerLink]="[]" fragment="d">D</a>
        <a [routerLink]="[]" fragment="e">E</a>
        <a [routerLink]="[]" fragment="f">F</a>
        <a [routerLink]="[]" fragment="g">G</a>
        <a [routerLink]="[]" fragment="h">H</a>
        <a [routerLink]="[]" fragment="i">I</a>
        <a [routerLink]="[]" fragment="j">J</a>
        <a [routerLink]="[]" fragment="k">K</a>
        <a [routerLink]="[]" fragment="l">L</a>
        <a [routerLink]="[]" fragment="m">M</a>
        <a [routerLink]="[]" fragment="n">N</a>
        <a [routerLink]="[]" fragment="o">O</a>
        <a [routerLink]="[]" fragment="p">P</a>
        <a [routerLink]="[]" fragment="q">Q</a>
        <a [routerLink]="[]" fragment="r">R</a>
        <a [routerLink]="[]" fragment="s">S</a>
        <a [routerLink]="[]" fragment="t">T</a>
        <a [routerLink]="[]" fragment="u">U</a>
        <a [routerLink]="[]" fragment="v">V</a>
        <a [routerLink]="[]" fragment="w">W</a>
        <a [routerLink]="[]" fragment="x">X</a>
        <a [routerLink]="[]" fragment="y">Y</a>
        <a [routerLink]="[]" fragment="z">Z</a>
    </div>
</div>

<div class="mt-3">
    <ul><span id="a" class="section-header">A</span>
        <li class="glossary-item"><span class="glossary-term">ADAMS</span> - Agencywide Documents Access and Management
            System (ADAMS) is the official recordkeeping system, through which the U.S. Nuclear Regulatory Commission
            (NRC) provides access to the following "libraries" or collections of publicly available documents</li>
        <li class="glossary-item" id="accessionNumber">
            <span class="glossary-term">Accession Number</span> - System generated ID assigned with a document or
            package is first added to an ADAMS Library. Consists of the following elements:
            <ul>
                <li>2 Character Alpha Code, e.g., "ML" to indicate the original Library</li>
                <li>9 Character Numeric Code, known as the "ADAMS Item ID"</li>
            </ul>
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Addressee Affiliation</span> - The name of the organization receiving agency
            documents.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Addressee Name</span> - The name of the individual(s) to whom the document is
            addressed.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Author Affiliation</span> - The name of the organization which originated the
            document.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Author Name</span> - The name of the individual(s) who approved the document or
            is listed in the title page of the publication.
        </li>
    </ul>
    <ul>
        <span id="c" class="section-header">C</span>
        <li class="glossary-item">
            <span class="glossary-term">Case Reference Number</span> - A unique number and/or name that refers to a
            specific action or identification of a document and is applied to all related documents and associated
            records. For example, "FOIA/PA-2001-0012" and "TAC MB8992"
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Comment</span> - Additional textual information deemed important about the
            document.
        </li>
    </ul>
    <ul><span id="d" class="section-header">D</span>
        <li class="glossary-item">
            <span class="glossary-term">Date Added</span> - Date document was added to ADAMS.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Date Docketed</span> - The date that a document is officially accepted by the
            NRC’s Office of the Secretary (SECY) as part of an adjudicatory record of an agency hearing. This may or may
            not be the date the document was received at NRC.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Distribution List Codes</span> - Code used to provide distribution notification
            of the document, including external recipients. For example, "NMSS10", "SECY01", and "AP01".
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Docket Number</span> - An NRC-assigned number that uniquely identifies a
            facility, licensee, or activity. The first three digits represent the associated part of the 10 CFR. The
            (MV) designates that this is a Multi-Valued property, meaning that more than one Docket Number may be
            selected, if appropriate. For example "05000259" and "WM--00011".
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Document Date</span> - The date of the document. For example, the date on a
            letter or memorandum; or another date assigned to the document following office business rules for date
            fields.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Document Report Number</span> - A unique number used to identify/retrieve the
            actual document. Will include any of its derivatives, such as the new edition, revision, supplement, or
            errata data. Ex.: "NUREG/CR-0927, Rev 2"
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Document Title</span> - A brief description of the subject and/or contents of a
            document.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Document Type</span> - Indicates a specific document type:
            <ul>
                <li>NRC Bulletin</li>
                <li>Contract</li>
                <li> SECY Paper</li>
            </ul>
        </li>
    </ul>

    <ul><span id="e" class="section-header">E</span>
        <li class="glossary-item">
            <span class="glossary-term">Electronic Hearing Dockets</span> -
            A document associated with an active or closed adjudicatory proceeding.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Exhibit Status</span> -
            Indicator of when an Exhibit was Identified, Admitted and Stricken from a proceeding.
        </li>
    </ul>

    <ul><span id="k" class="section-header">K</span>
        <li class="glossary-item">
            <span class="glossary-term">Keyword</span> -
            Information describing the document, SUNSI review information and Designation Code if Non-Public, ADAMS
            Template # (when submitting NRC generated documents for DPC processing).
            <ul>
                <li>CATEGORY A: Sensitive Unclassified Non-Safeguards Information (SUNSI)</li>
                <li>CATEGORY B: Non-Public/Non-Sensitive Records</li>
            </ul>
        </li>
    </ul>
    <ul><span id="l" class="section-header">L</span>
        <li class="glossary-item">
            <span class="glossary-term">License Number</span> - An NRC or State assigned number identifying an NRC or
            State License or Permit holder.
        </li>
    </ul>
    <ul><span id="p" class="section-header">P</span>
        <li class="glossary-item"><span class="glossary-term">Publicly Available Records System (PARS) Library</span> -
            contains more than 2 million full-text documents that the NRC has released since November 1, 1999, and
            several hundred new documents are added each day.
            From July 2019 to December 2020, the agency digitized more than 1 million documents from the public legacy
            library to the PARS Library.</li>
        <li class="glossary-item"><span class="glossary-term">Package</span> - Main library item which is a grouping of
            2 or more related documents.</li>
        <li class="glossary-item">
            <span class="glossary-term">Package Number</span> - Indicates the <a [routerLink]="[]" fragment="accessionNumber">Accession
                Number</a> of the ADAMS package in which
            the document resides.
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Party Exhibit Number</span> - Number Assigned by the Party for pre-filed exhibits
        </li>
        <li class="glossary-item">
            <span class="glossary-term">Protective Order Files (POF)</span> - A document related to an adjudicatory proceeding that has been declared sensitive by judicial order 
        </li>
    </ul>
    <ul><span id="s" class="section-header">S</span>
        <li class="glossary-item">
            <span class="glossary-term">Staff Discovery Material</span> - Documents related to an adjudicatory proceeding made public by the NRC Office of General Counsel 
        </li>
    </ul>
</div>